const formatHour = (hoursData) => {
  const validHourRegex = /\d{3,4}/;
  if (!hoursData) {
    return "";
  }
  let hour;
  hour = hoursData.toString();
  hour = hour.length === 3 ? `0${hour}` : hour;
  if (validHourRegex.test(hour)) {
    const hours = hour.length === 4 ? hour.slice(0, 2) : `0${hour.slice(0, 1)}`;
    const minutes = hour.length === 4 ? hour.slice(2) : hour.slice(1);
    return `${hours}:${minutes}`;
  } else {
    return "unknown";
  }
};
export {
  formatHour
};
//# sourceMappingURL=format-hour.js.map
